module.exports = __webpack_public_path__ + "static/piechart-d8d3ca0ea03a2c42319edc00db3d4b65.png";